import cssVar from '@styles/_export'

// see: https://react-select.com/styles#style-object
const customStyles = {
  container: (provided) => ({
    ...provided,
    flex: '1 1',
    width: '100%'
  }),
  control: (provided, { menuIsOpen }) => {
    const borderRadius = 6

    return {
      ...provided,
      transition: 'none',
      borderRadius,
      borderBottomRightRadius: menuIsOpen ? 0 : borderRadius,
      borderBottomLeftRadius: menuIsOpen ? 0 : borderRadius,
      /*
        do not use borderBottomWidth. the component move a bit up and down if we change
        the borderWidth
      */
      borderBottomColor: menuIsOpen ? 'transparent' : '#737476',
      boxShadow: 'none',
      borderColor: '#737476',
      ':hover': {
        borderColor: '#737476',
        borderBottomColor: menuIsOpen ? 'transparent' : '#737476'
      },
      cursor: 'pointer',
      flexWrap: 'nowrap',
      overflow: 'hidden'
    }
  },
  menu: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
    borderRadius: 0,
    border: 1,
    borderColor: '#737476',
    borderStyle: 'solid',
    width: '137%',
    minWidth: 230
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: 0
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    // paddingLeft: 0,
    color: '#000000',
    ':hover': {
      color: '#000000'
    }
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: '#ffffff',
    color: state.isFocused ? cssVar.rbRed : '#000000',
    cursor: 'pointer',
    padding: '0 16px'
  }),
  valueContainer: (provided) => ({
    ...provided,
    ':hover': {
      color: cssVar.hoverColor
    },
    padding: 11,
    paddingLeft: 16
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'inherit',
    fontSize: '14px'
  }),
  // indicatorSeparator: () => ({}),
  placeholder: (provided) => ({
    ...provided,
    whiteSpace: 'nowrap',
    fontSize: '14px'
  })
}

export default customStyles
